import { configure, flow, makeAutoObservable } from "mobx";
import { createContext } from "react";
import ClientStore from "./ClientStore";
import DateStore from "./DateStore";
import { DEV_MODE } from "../consts";
import { InfluxStore } from "./InfluxStore";
import { GoogleAuthStore } from "./GoogleAuthStore";

configure({
  enforceActions: "always",
});

export class RootStore {
  influxStore: InfluxStore;
  clientStore: ClientStore;
  dateStore: DateStore;
  googleAuthStore: GoogleAuthStore;

  constructor() {
    this.influxStore = new InfluxStore(this);
    this.googleAuthStore = new GoogleAuthStore(this);

    this.clientStore = new ClientStore(this);
    this.dateStore = new DateStore(this);

    if (DEV_MODE) {
      (document as any).rootStore = this;
    }

    makeAutoObservable(this);

    this.Initialize();
    this.clientStore.Initialize();
    this.influxStore.Initialize();
  }

  Initialize = flow(function* () {});
}

export const rootStore = new RootStore();
export const StoreContext = createContext(rootStore);
